import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import App from './App.vue'
import Vant from 'vant'
import 'lib-flexible'
import 'vant/lib/index.css'
import VueClipboard from 'vue-clipboard2'
import '@/pwa/registerServiceWorker'
import vuePlugin from '@/utils/vuePlugin'
import cookie from 'js-cookie'
import { setStorage, getStorage, parseTime } from '@/utils'
import '@/utils/huatuo.js'
const ENV = process.env.VUE_APP_ENV

if (['local', 'development'].includes(ENV)) {
  let VConsole = require('vconsole')
  new VConsole()
} else {
}

if (!getStorage('studentId') && cookie.get('mbstudentid')) {
  setStorage('studentId', cookie.get('mbstudentid'))
}

Vue.filter(parseTime)

Vue.use(VueClipboard)
Vue.use(vuePlugin)

Vue.use(Vant)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
